// extracted by mini-css-extract-plugin
export default {"container":"InfoBlock_container__TcSe9","heading":"InfoBlock_heading__YsMD+","row":"InfoBlock_row__pW99c","body":"InfoBlock_body__hjUXs"};